import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ThemeService } from '@wind-log_library/fe-component-library';
import { LocalStorageService } from 'app/shared/services/local-storage-service/local-storage.service';
import { LogoutService } from 'app/shared/services/logout-service/logout.service';
import { UserStatsService } from 'app/shared/services/user-stats/user-stats.service';
import { environment } from 'environments/environment';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-logout-message',
    templateUrl: './logout-message.component.html',
    styleUrls: ['./logout-message.component.scss'],
    standalone: false
})
export class LogoutMessageComponent implements OnInit {
  public theme: string;
  public modalRef: BsModalService;
  constructor(
    private themeService: ThemeService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private userStatsService: UserStatsService,
    private logoutService: LogoutService
  ) {}
  
  ngOnInit() {
    this.theme = this.themeService.getTheme().value;
  }

  public logout(): void {
    this.close();
    this.logoutService.logout();
  }

  public close(): void {
    this.modalRef.hide();
  }

  public onSignOut(event) {
    this.userStatsService.logout();
    if (environment.auth_enabled) {
      this.localStorageService.clearLocalStorage();
      this.userStatsService.logout();
      this.logoutService.logout();
    } else {
      this.router.navigateByUrl('/login?loggedIn=false');
    }
  }
}
